import { CREATEUSER_ACTIONS } from "./CreateUser.actions";


export const CreateUserReducer = (state, action) => {
  switch (action.type) {
    case CREATEUSER_ACTIONS.LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case CREATEUSER_ACTIONS.ERROR:
      return {
        ...state,
        error: action.payload,
      };
    default:
      return { ...state };
  }
};
